import logo from './logo.svg';
import './App.css';
import VideoPlayer from './VideoPlayer';

function App() {
  const hlsUrl = 'https://srv1053170.hstgr.cloud/hls/bragadotv.m3u8';
  const inframe = " https://srv1053170.hstgr.cloud/"
  /*   setInterval(() => {
      fetch("https://backend.sib-2000.com.ar/s2k/stats/viewer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ stream: "bragadotv" }),
      });
    }, 15000); // cada 15 segundos */
  return (
    <div className="App">
      <iframe style={{ overflow: "hidden", scrollbars: "none", scrollbarWidth: 0, border: 0, margin: 0, padding: 0 }}
        src={inframe}
        title="Tranmision Bragado TV"
        width="100%"
        height="1000px"
        allowFullScreen
        scrolling='none'
      ></iframe>
{/*       <iframe style={{ overflow: "hidden", border: 0, margin: 0, padding: 0 }}
        src="https://backend.sib-2000.com.ar/s2k/stats/stats"
        title="Estadisticas web player"
        width="100%"
        height="80px"
        allowFullScreen
      ></iframe>
      <iframe style={{ overflow: "hidden", border: 0, margin: 0, padding: 0 }}
        src="https://srv1053170.hstgr.cloud/stat"
        title="Estadisticas rtmp"
        width="100%"
        height="200px"
        allowFullScreen
      ></iframe>
 */}
      {/*       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <VideoPlayer
          thumbnail="https://bragadotv-s3.cdn.net.ar/s3i233/2025/09/bragadotv/files/02/01/20146/de18b68911899311f45ce676045b90dc4c4e984b0ed4a66e411d2ecdffb0433a.gif"
          videoUrl={hlsUrl}
        />
      </div> */}
    </div>
  );
}

export default App;
